export default "* 9a18bb3\t 2026-01-30T22:23:30-03:00 ";